import { ILocalTargetingParameter } from '~/src/dash/components/local-targeting/local-targeting';

function stringify(val: any): string {
  if (val === null || val === undefined) {
    return '';
  }
  if (typeof val === 'function') {
    return stringify(val());
  }
  if (typeof val === 'object') {
    try {
      return JSON.stringify(val);
    } catch {
      return 'ERROR';
    }
  }
  return '' + val;
}

export function encodeParams(params: { [key: string]: any } | string): string {
  if (typeof params === 'string') {
    return params;
  }
  return Object.keys(params)
    .map((key: string) => {
      return encodeURIComponent(key) + '=' + encodeURIComponent(stringify((params as any)[key]));
    })
    .join('&');
}

export function importLocalTargetingParamFromJSON(inputJSON: string) {
  let localParams: ILocalTargetingParameter[] = [];
  if (inputJSON === undefined || inputJSON.length === 0) {
    return localParams;
  }
  try {
    localParams = (JSON.parse(inputJSON) as object[]).map((o: ILocalTargetingParameter) => ({
      ...o,
      areDMAsCommaSeparated: o.areDMAsCommaSeparated === undefined ? true : o.areDMAsCommaSeparated,
      currentValue: '',
    }));
  } catch (e) {
    // Ignore JSON parse errors
  }
  return localParams;
}

export function exportLocalTargetingToJSON(localParams: ILocalTargetingParameter[]) {
  return localParams.map((param: ILocalTargetingParameter) => {
    if (param.type === 'country') {
      return {
        type: param.type,
        country: param.country,
        states: param.states
          .split(',')
          .map((state: string) => state.trim())
          .join(','),
        cities: param.cities
          .split(',')
          .map((city: string) => city.trim())
          .join(','),
        zips: param.zips
          .split(',')
          .map((zip: string) => zip.trim())
          .join(','),
        dmas: param.dmas
          .split(',')
          .map((dma: string) => dma.trim())
          .join(','),
        areCitiesCommaSeparated: param.areCitiesCommaSeparated,
        areStatesCommaSeparated: param.areStatesCommaSeparated,
        areDMAsCommaSeparated: param.areDMAsCommaSeparated,
      };
    } else {
      return {
        type: param.type,
        value: param.value
          .split(',')
          .map((val: string) => val.trim())
          .join(','),
        isInputInCommaSeparatedMode: param.isInputInCommaSeparatedMode,
      };
    }
  });
}
